module.exports = __webpack_public_path__ + "images/home-dingtalk-work/article-member-636034502747cf3794ab3e6e13b25325.png";